module.exports = __webpack_public_path__ + "static/media/services-icon1.7bd97ea7.png";